import { render, staticRenderFns } from "./commission-inspection.vue?vue&type=template&id=4c2c5f71&scoped=true"
import script from "./commission-inspection.vue?vue&type=script&lang=js"
export * from "./commission-inspection.vue?vue&type=script&lang=js"
import style0 from "./commission-inspection.vue?vue&type=style&index=0&id=4c2c5f71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c5f71",
  null
  
)

export default component.exports